import { http } from "../http/Http";
import { Direction } from "../models/Direction";
import { ServiceResponse } from "../models/ServiceResponse";

export class DirectionService {

    getDirections = async (): Promise<ServiceResponse<Direction[]>> => {
        const { data } = await http.get<ServiceResponse<Direction[]>>("Direction/GetAll");
        return data;
    };

}